import React from 'react';
import { Card, Drawer, Timeline, Avatar, Tabs, Select, Input, Button, Layout, Menu, Icon, Row, Col, Table, Divider } from 'antd';
import ReactCodeMirror from '@skidding/react-codemirror';
import CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/markdown/markdown';
import 'codemirror/keymap/sublime';
import 'codemirror/addon/display/placeholder';
import 'codemirror/addon/comment/comment';
import 'codemirror/addon/comment/continuecomment';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/edit/closebrackets';
import 'codemirror/addon/selection/active-line';
import 'codemirror/addon/search/match-highlighter';
import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/addon/hint/show-hint';
import VBQLArea from './VBQLArea';

import './queryEditor.less';

import './vbql/mode';
import './vbql/hint';
import './vbql/prediction';

const debounce = (func, wait, immediate) => {
  let timeout;
  return (...args) => {
    const context = this;
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

class QueryEditor extends React.Component {
  shouldComponentUpdate(nextProps) {
    return (
      Object.keys(nextProps).some(key => this.props[key] !== nextProps[key])
    );
  }

  handleChange = debounce((vbql) => {
    const { onChange } = this.props;
    onChange(vbql);
  }, 100);

  handleRun = () => {
    const { onRun, query } = this.props;
    onRun(query.vbql);
  };

  render() {
    const { running, query } = this.props;

    return (
      <Card
        bordered={false}
        bodyStyle={{ padding: '0' }}
      >
        <Row
          style={{
            background: '#f7f7f7',
            padding: '8px',
            border: '1px solid #d9d9d9',
            borderBottom: 'none',
          }}
          type="flex"
          justify="space-between"
          align="middle"
        >
          <Col>
            <h4 style={{ marginBottom: '0', padding: '0 8px' }}>VBQL Editor</h4>
          </Col>
          <Col>
            <Button icon="play-circle" loading={running} onClick={this.handleRun}>Run</Button>
          </Col>
        </Row>
        <VBQLArea inline={false} value={query.vbql} onChange={this.handleChange} onRun={this.handleRun} />
      </Card>
    );
  }
}

export default QueryEditor;
// padding: '54px 101px 65px 201px',
